import React, { useState, useRef, useEffect } from 'react';
import PlusIcon from "../../assets/images/plus-rounded.svg";
import MinusIcon from "../../assets/images/minus-red.svg";
import { useResume } from '../../context/ResumeContext';
import { squareBracketTextColor, stripTags } from '../../helper';
import { safeFilterByStringProperty } from '../../utils/stringUtils';
import DraftEditor from './DraftEditor';
import axios from 'axios';

const PhrasesPopup = (props) => {
    const {
        resume: {
          summary
        },
        getDefaultPhrases,
        getPhrases
    } = useResume();

    const [defaultPhrases, setDefaultPhrases] = useState(null);
    const [sectionPhrases, setSectionPhrases] = useState(null);
    let [phrasedata, setPhraseData] = useState([]);
    const [phraseSearchValue, setPhraseSearchValue] = useState('');
    const [intialListings, setInitialListings] = useState(true);
    let [phraseSummary, setPhraseSummary] = useState('');
    const [buttonClass,setButtonClass]=useState('');
    const phrase = props.phrase;

    useEffect(() => {
      getDefaultPhrases(props.section, (res) => {
        //prepare the default phrases object
        const dp = {}
        dp[props.section] = res
        //set default phrases
        setDefaultPhrases({...dp});
      });
      getPhrases(props.section, (res) => {
        //prepare the section phrases object
        const sp = {}
        sp[props.section] = res
        //set section phrases
        setSectionPhrases({...sp});
      });
    }, []);

    const currRef = useRef();
    useEffect(() => {
      if(sectionPhrases != null){
        if(!currRef.current){
          //resetPhraseData();
          //setPhraseSearchValue(phrase);
          currRef.current = true;
        }
        // Fix: RESUMEORG-REACT-3M - Ensure phrase is a string before calling .trim()
        if(phrase && typeof phrase === 'string' && phrase.length){
          resetPhraseData();
          setInitialListings(false);
          if (props.section && sectionPhrases[props.section]) {
            let phrasedataNew = sectionPhrases[props.section].filter(p => 
              p && p.jobTitle && typeof p.jobTitle === 'string' && 
              p.jobTitle.toLowerCase().includes(phrase.trim().toLowerCase())
            );
            if(!phrasedataNew.length) phrasedataNew = defaultPhrases[props.section];
            setPhraseData(phrasedataNew);
          }
        }else{
          resetDefaultPhraseData();
          setPhraseData(defaultPhrases[props.section]);
        }
      }
    }, [phrase, defaultPhrases, sectionPhrases]);

    const handleActiveState = (callback) => {
      if(typeof callback == 'function'){
        setTimeout(function(){          
          callback();
        },20);
        
      }
    }

    /*
    const resetPhraseData = () => {
        for(let i = 0; i < sectionPhrases[props.section].length; i++){
          sectionPhrases[props.section][i].plusIcon = 'yes';
          sectionPhrases[props.section][i].minusIcon = 'no';
        }
        setPhraseData(sectionPhrases[props.section]);
    }
    */

    const resetPhraseData = () => {
      if(sectionPhrases != null && props.section && sectionPhrases[props.section]){
        const updatedPhrases = sectionPhrases[props.section].map(phrase => ({
          ...phrase,
          plusIcon: 'yes',
          minusIcon: 'no'
        }));
        setPhraseData(updatedPhrases);
      }
    }

    const changePhraseStatus = (phrasecontent, clickedItem) => {
      let phrasedataNew = phrasedata.map((v) => {
          if(v.content == phrasecontent){
              switch(clickedItem){
                  case 'plus':
                      v.plusIcon = 'no';
                      v.minusIcon = 'yes';
                      break;
                  case 'minus':
                      v.plusIcon = 'yes';
                      v.minusIcon = 'no';
                      break;
                  default:
                      //do nothing..
                      break;
              }
          }
          return v;
      });   
      setPhraseData(phrasedataNew)
    }

    const updateContent = (phrasecontent, clickedItem) => {
      // Add null check for summary
      if (!summary) {
        console.warn('updateContent: summary is null/undefined');
        return;
      }
      
      const phrasecontent2 = (props.section == 'heading' ? `<p>${phrasecontent}</p>` : `<li>${phrasecontent}</li>`);
      if(clickedItem == 'plus' && phrasecontent != ''){
          switch(props.section){
              case 'heading':
                  //summary.content = stripTags(summary.content, ['ul']); //commented for the tickets #569 and #600
                  summary.content = summary.content
                  .replace(/<li><br><\/li>/g, '')
                  .replace(/<li><\/li>/g, '')
                  .replace(/<p><br><\/p>/g, '')
                  .replace(/<p><\/p>/g, '');
                  summary.content += phrasecontent2;
                  // summary.content = `<ul>${summary.content}</ul>`; //commented for the tickets #569 and #600
                  /**
                   * START
                   * Append the <li> content according to <ol> and <ul>
                   * Ticket ID: https://gitlab.dailyrssmail.com/growthlabs/resumebuilder-app/-/issues/600
                   * Date: 2024-01-18
                   */
                  // if(summary.content.slice(-5) == '</ol>')
                  //   summary.content = summary.content.replace(/<\/ol>$/, `${phrasecontent2}</ol>`);
                  // else if(summary.content.slice(-5) == '</ul>')
                  //   summary.content = summary.content.replace(/<\/ul>$/, `${phrasecontent2}</ul>`);
                  // else 
                  //   summary.content += phrasecontent2;
                  /**
                   * END
                   */
                  props.updateAction({ summary: summary, current_tab: 'summary' });
                  break;
              case 'work_history':
              case 'education_history':
                  // props.data.description = stripTags(props.data.description, ['ul']); //commented for ticket #600
                  props.data.description = props.data.description
                  .replace(/<li><br><\/li>/g, '')
                  .replace(/<li><\/li>/g, '')
                  .replace(/<p><br><\/p>/g, '')
                  .replace(/<p><\/p>/g, '');
                  // props.data.description += phrasecontent2; //commented for ticket #600
                  // props.data.description = `<ul>${props.data.description}</ul>`; //commented for ticket #600
                  /**
                   * START
                   * Append the <li> content according to <ol> and <ul>
                   * Ticket ID: https://gitlab.dailyrssmail.com/growthlabs/resumebuilder-app/-/issues/600
                   * Date: 2024-01-18
                   */
                  if(props.data.description.slice(-5) == '</ol>'){
                    props.data.description = props.data.description.replace(/<\/ol>$/, `${phrasecontent2}</ol>`);
                    props.data.description = stripTags(props.data.description, ['ol']); // changes for #974
                    props.data.description = `<ol>${props.data.description}</ol>`; // changes for #974
                  }else if(props.data.description.slice(-5) == '</ul>'){
                    props.data.description = props.data.description.replace(/<\/ul>$/, `${phrasecontent2}</ul>`);
                    props.data.description = stripTags(props.data.description, ['ul']); // changes for #974
                    props.data.description = `<ul>${props.data.description}</ul>`; // changes for #974
                  }else{
                    props.data.description += phrasecontent2;
                    props.data.description = stripTags(props.data.description, ['ul']); // changes for #974
                    props.data.description = `<ul>${props.data.description}</ul>`; // changes for #974
                  }
                  /**
                   * END
                   */
                  props.updateAction({ description: props.data.description }, props.id);
                  break;
              case 'custom':
                  props.data.content = props.data.content.replace(/<p><br><\/p>/g, '')
                  .replace(/<p><\/p>/g, '');
                  props.data.content += phrasecontent2;
                  props.updateAction({ content: props.data.content }, props.id);
                  break;
              default:
                  //do nothing..
                  break;
          }
          phraseSummary += phrasecontent2;
      } else if(clickedItem == 'minus'){
          switch(props.section){
              case 'heading':
                  summary.content = summary.content
                  .replace(phrasecontent, '')
                  .replace(/<li><\/li>/g, '')
                  .replace(/<p><\/p>/g, '');
                  props.updateAction({ summary: summary, current_tab: 'summary' });
                  break;
              case 'work_history':
              case 'education_history':
                  props.data.description = props.data.description
                  .replace(phrasecontent, '')
                  .replace(/<li><\/li>/g, '')
                  .replace(/<p><\/p>'/g, '');
                  props.updateAction({ description: props.data.description }, props.id);
                  break;
              default:
                  //do nothing..
                  break;
          }
          phraseSummary = phraseSummary.replace(phrasecontent, '');
      }
      setPhraseSummary(phraseSummary);
    }
    
    const phraseClickHandler = (phrasecontent, clickedItem = 'plus') => {
      changePhraseStatus(phrasecontent, clickedItem);
      updateContent(phrasecontent, clickedItem);
    }

    const updatePhraseSearchString = (phrase) => {
      setPhraseSearchValue(phrase);
    }

    const searchClickHandler = () => {
      resetPhraseData();
      setInitialListings(false);
      
      // Add null checks for sectionPhrases and props.section
      if (!sectionPhrases || !props.section) {
        console.warn('searchClickHandler: sectionPhrases or props.section is null/undefined');
        return;
      }
      
      if (!sectionPhrases[props.section]) {
        console.warn(`No section phrases found for: ${props.section}`);
        return;
      }
      
      let phrasedataNew = safeFilterByStringProperty(
        sectionPhrases[props.section], 
        'jobTitle', 
        phraseSearchValue.trim()
      );
      if(!phrasedataNew.length && defaultPhrases && props.section && defaultPhrases[props.section]) {
        phrasedataNew = defaultPhrases[props.section];
      }
      setPhraseData(phrasedataNew);
    }

    const resetDefaultPhraseData = () => {
      // Check if defaultPhrases exists and props.section is valid
      if (!defaultPhrases || !props.section) {
        console.warn('resetDefaultPhraseData: defaultPhrases or props.section is null/undefined');
        return;
      }
      
      if (!defaultPhrases[props.section]) {
        console.warn(`No phrases found for section: ${props.section}`);
        return; // Early exit if there are no default phrases
      }
      
      for(let i = 0; i < defaultPhrases[props.section].length; i++){
        defaultPhrases[props.section][i].plusIcon = 'yes';
        defaultPhrases[props.section][i].minusIcon = 'no';
      }
      //setPhraseData(defaultPhrases[props.section]);
    }

    const enter = (e) => {
      if(e.key === 'Enter'){
        e.preventDefault();
        e.stopPropagation();
        searchClickHandler();
      }
    }

    const ref = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
              props.setShowPhrasePopUp(false);
              let btns = document.querySelectorAll('.draft-controls .phrases-wrap .phrases');
              btns.length && btns.forEach(function(curr,index,btns){
                btns[index].classList.remove('active');
              });                  
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    });

    const editorContent = () => {
      switch(props.section){
        case 'heading':
          return summary.content;
        case 'work_history':
        case 'education_history':
          return props.data.description;
        case 'custom':
          return props.data.content;
        default:
          //do nothing..
          break;
      }
    }

    const updatePhraseSummaryValue = (val) => {
      switch(props.section){
        case 'heading':
          props.updateAction({ summary: { content: val }, current_tab: 'summary' });
          break;
        case 'work_history':
        case 'education_history':
          props.updateAction({ description: val }, props.id);
          break;
        default:
          //do nothing..
          break;
      }
      setPhraseSummary(val);
    }

    return (<>
      <div className="phrases-popup-wrap" ref={ref}>
       <div className="close-it">
        <span className="close" 
            onClick={
              () => { 
                props.setShowPhrasePopUp(false);
                resetPhraseData(); 
                resetDefaultPhraseData();
                handleActiveState(function(){
                  let btns = document.querySelectorAll('.draft-controls .phrases-wrap .phrases');
                  btns.length && btns.forEach(function(curr,index,btns){
                    btns[index].classList.remove('active');
                  });
                }); 
              }
                }>
              <i className="icon-cross-icon"></i>
            </span>
            </div>
          <div className="phrases-block">
            <div className="left-block">
              {props.section != 'education_history' && <><label className="popup-label">Search our expert-suggested phrases based on your job title.</label>
              <div className="field-wrap">
                <input 
                  type="text" 
                  name="phrase-search" 
                  defaultValue={phrase ?? phraseSearchValue} 
                  onChange={(e) => updatePhraseSearchString(e.target.value)}
                  onKeyDown={e => enter(e)} />
                <span className="search" onClick={searchClickHandler}><i className="icon-search-icon"></i></span>
              </div></>}
              <div className="phrase-list-wrap">
                <div className="result-list">
                    <ul>
                        {
                          phrasedata.map((v, k) => {
                              if(intialListings && k == 10)
                                return null;
                              else
                                return (<li onClick={() => phraseClickHandler(v.content, (v.plusIcon == 'yes' ? "plus" : 'minus'))} key={`phrasedata-${k}`}>
                                      <span className={(v.plusIcon == 'yes' ? "icon plus-sign" : (v.minusIcon == 'yes' ? "icon minus-sign" : 'icon'))}>
                                          {(v.plusIcon == 'yes' ? <PlusIcon /> : (v.minusIcon == 'yes' ? <MinusIcon /> : ''))}
                                      </span>
                                      <div className="list-item" dangerouslySetInnerHTML={{__html: squareBracketTextColor(v.content, "#FE4959")}}></div>
                                </li>);
                          })
                        }
                    </ul>
                  </div>  
              </div>
            </div>
            <div className="right-block">
              <div className="ai-editor_wrap">
                <DraftEditor 
                  name="description"
                  className="validate"
                  textAlignment='left'
                  value={editorContent()} 
                  onInputChange={(val) => {
                    updatePhraseSummaryValue(val);
                  }}
                />
              </div>
            </div>
          </div>
          
      </div>
    </>);
}

export default PhrasesPopup;